import fullpage from 'fullpage.js/jquery.fullPage.js';
import jqueryMousewheel from 'jquery-mousewheel';
import malihuCustomScrollbarPlugin from 'malihu-custom-scrollbar-plugin';
import is from 'is_js';

export default class Site {
	constructor() {
		this.fullpageInited = false;
		this.sectionSpeed = 1000;
		this.sectionEasing = 'easeInOutCubic';

		this.itemCurrent = null;
		this.itemPrevious = null;

		this.dotCurrent = null;
		this.dotPrevious = null;

		this.sectionCurrent = null;

		this.keys = {37: 1, 38: 1, 39: 1, 40: 1};

		new jqueryMousewheel($);
		new malihuCustomScrollbarPlugin($);

		this.init();
	}

	init() {
		var that = this;

		this.deviceClass;
		this.setDeviceClass();

		document.ontouchmove = function(event){
			event.preventDefault();
		}

		$('#fullpage').fullpage({
			scrollOverflow: false,
			scrollingSpeed: that.sectionSpeed,
			easing: that.sectionEasing,
			responsiveSlides: true,
			alwaysShowScrollbar: 2,
			normalScrollElements: '.mCustomScrollbar, .overlay, .overlay .content, .overlay .mCustomScrollBox, .overlay .mCSB_container, .menuPanel, .menuPanel >*',
			// verticalCentered: false,
			onLeave: (index, nextIndex, direction) => {
				this.displayHeader(nextIndex);
				this.updateElementsColor(nextIndex);

				let section = $($('#fullpage').find('.section')[nextIndex - 1]);

				if(section.hasClass('partenaires')) {
					this.updateMosaic();
				}

				this.initEffects(nextIndex);

				this.toggleMenu(false);

				this.toggleNav(!section.hasClass('intro'));
			},
			afterLoad: (anchorLink, index) => {
				this.sectionCurrent = anchorLink;
				this.sectionCurrent = anchorLink;

				if(!this.fullpageInited) {
					this.displayBody();
				}

				this.updateNav(anchorLink);
				this.updateMenu(anchorLink);

				// if(anchorLink === 'ils-nous-soutiennent-deja') {
				// 	this.updateMosaic();
				// }

				this.runEffects(anchorLink);
			},
			afterRender: function(){},
			afterResize: function(){},
			afterSlideLoad: function(anchorLink, index, slideAnchor, slideIndex){},
			onSlideLeave: function(anchorLink, index, slideIndex, direction, nextSlideIndex){}
		});

		this.handleEvents();
	}

	setDeviceClass() {
		let w = $(window).width();

		if(w <= 768) {
			this.deviceClass = 'width-0-768';
		} else if(w > 768 && w <= 1024) {
			this.deviceClass = 'width-768-1024';
		} else if(w > 1024) {
			this.deviceClass = 'width-1024-infinity';
		}

		$('body').removeClass('width-0-768 width-768-1024 width-1024-infinity').addClass(this.deviceClass);
	}

	/*
	██████████████████████████████████████████
	█     ██ ███ ██     ██ ███ ██     ███   ██
	█ ██████ ███ ██ ██████ ███ ████ ████ ███ █
	█ ██████ ███ ██ ██████  ██ ████ ████ █████
	█   ████ ███ ██   ████ █ █ ████ █████   ██
	█ ███████ █ ███ ██████ ██  ████ ████████ █
	█ ███████ █ ███ ██████ ███ ████ ████ ███ █
	█     ████ ████     ██ ███ ████ █████   ██
	██████████████████████████████████████████
	██████████████████████████████████████████
	██████████████████████████████████████████
	*/
	handleEvents() {
		// navigation
		$('.dot').on('mouseover', (e) => {
			let dot = $(e.currentTarget);
			let color = dot.attr('data-color');

			this.activateNavDot(dot, color);
		});

		$('.dot').on('mouseout', (e) => {
			let dot = $(e.currentTarget);
			let color = dot.attr('data-color');

			if(dot.attr('id') !== this.dotCurrent.attr('id')) {
				this.deactivateNavDot(dot, color);
			}
		});

		// menu
		$('.menu').on('click', (e) => {
			this.toggleMenu();
		});

		$('.menuPanel').find('.item[data-type="sous-rubrique"]').on('click', (e) => {
			this.toggleMenu(false);
		});

		this.handleEventsCustom();

		// resize
		$(window).bind('resize', {context: this}, () => {
			$('#fullpage').fullpage.reBuild();

			this.setDeviceClass();

			this.handleEventsCustom();

			this.updateBlocks();

			if(this.deviceClass === 'width-0-768' || this.deviceClass === 'width-768-1024') {
				this.setOverlayScrollbar();
			}

			if(this.sectionCurrent === 'ils-nous-soutiennent-deja') {
				this.updateMosaic();
			}
		});

		/*
		$('.section.formulaire-contact').find('form').find('input[type=submit]').on('click', (e) => {
			console.log('FORM SUBMITTED');

			this.updateBlocks();
		});

		$('.section.formulaire-contact').find('div[role="form"]').on('wpcf7:invalid invalid.wpcf7 wpcf7:spam spam.wpcf7 wpcf7:mailsent mailsent.wpcf7 wpcf7:mailfailed mailfailed.wpcf7 wpcf7:submit submit.wpcf7', (e) => {
			console.log('FORM UPDATED');

			window.setTimeout(() => {
				this.updateBlocks();
			}, 2000);
		});
		*/
	}

	handleEventsCustom() {
		let sectionsTitles = $('.section[data-mobileLikeDesktop="false"]').find('.title');
		let overlayButtonClose = $('.overlay').find('.button-close');

		sectionsTitles.off('click');
		overlayButtonClose.off('click');

		if(this.deviceClass === 'width-0-768' || this.deviceClass === 'width-768-1024') {
			sectionsTitles.on('click', (e) => {
				this.openOverlay();
			});

			overlayButtonClose.on('click', (e) => {
				this.closeOverlay();
			});
		}
	}

	displayHeader(nextIndex) {
		if(nextIndex > 1) {
			$('header').css({
				'display': 'block'
			}).animate({
				'opacity': 1
			}, this.sectionSpeed, this.sectionEasing);
		} else {
			$('header').animate({
				'opacity': 0
			}, this.sectionSpeed, this.sectionEasing, function() {
				$('header').css({
					'display': 'none'
				})
			});
		}
	}

	/*
	█████████████████████████████████████████████████
	█     ██     ██     ██     ███   ███     ███   ██
	█ ██████ ██████ ██████ ██████ ███ ████ ████ ███ █
	█ ██████ ██████ ██████ ██████ ████████ ████ █████
	█   ████   ████   ████   ████ ████████ █████   ██
	█ ██████ ██████ ██████ ██████ ████████ ████████ █
	█ ██████ ██████ ██████ ██████ ███ ████ ████ ███ █
	█     ██ ██████ ██████     ███   █████ █████   ██
	█████████████████████████████████████████████████
	█████████████████████████████████████████████████
	█████████████████████████████████████████████████
	*/
	updateBlocks() {
		let section = $('.section[data-anchor="' + this.sectionCurrent + '"]');

		$(section).find('.block').each((i, e) => {
			var marginV = $('body').height() * 0.02;
			var el = $(e);
			var elW = el.innerWidth();
			var elH = Math.ceil(el.innerHeight() - marginV);
			var bg = $(e).find('.bg');
			var cntnt = $(e).find('.cntnt');

			bg.width(elW).height($(e).find('.cntnt').height() + marginV).attr('data-width', elW).css({
				'max-width': elW + 'px'
			});

			// cntnt.find('.scrll').stop().mCustomScrollbar('destroy').css({
			// 	'height': 'auto'
			// });

			if(cntnt.find('.scrll').innerHeight() > elH) {
				cntnt.find('.scrll').attr('data-needScroll', 'true');
			} else {
				cntnt.find('.scrll').attr('data-needScroll', 'false');
			}

			if(cntnt.find('.scrll').attr('data-needScroll') === 'true') {
				cntnt.find('.scrll').stop().css({
					'height': elH + 'px'
				}).mCustomScrollbar({
					mouseWheel: { enable: true },
					scrollButtons: { scrollType: 'stepless' },
					keyboard: { scrollType: 'stepless' },
				});
			}
		});
	}

	initEffects(nextIndex) {
		let section = $('#fullpage').find('.section')[nextIndex - 1];
		let content = $(section).find('.content');
		let align;

		if(content.hasClass('top-right') || content.hasClass('bottom-right')) {
			align = 'right';
		} else if(content.hasClass('top-left') || content.hasClass('bottom-left')) {
			align = 'left';
		}

		$(section).find('.block').each((i, e) => {
			var marginV = $('body').height() * 0.02;

			let el = $(e);
			let elW = el.innerWidth();
			let elH = Math.ceil(el.innerHeight() - marginV);
			let bg = $(e).find('.bg');
			let cntnt = $(e).find('.cntnt');

			bg.stop().width(elW).height($(e).find('.cntnt').height() + marginV).attr('data-width', elW).css({
				[align]: 0,
				'max-width': 0
			});

			cntnt.stop().css({
				'opacity': 0
			});

			cntnt.find('.scrll').stop().css({
				'height': 'auto'
			});

			if(cntnt.find('.scrll').innerHeight() > elH) {
				cntnt.find('.scrll').attr('data-needScroll', 'true');
			} else {
				cntnt.find('.scrll').attr('data-needScroll', 'false');
			}

			if(cntnt.find('.scrll').attr('data-needScroll') === 'true') {
				cntnt.find('.scrll').stop().css({
					'height': elH + 'px'
				}).mCustomScrollbar({
					mouseWheel: { enable: true },
					scrollButtons: { scrollType: 'stepless' },
					keyboard: { scrollType: 'stepless' },
				}).mCustomScrollbar('scrollTo', 'top');
			}
		});
	}

	runEffects(anchor) {
		let section = $('.section[data-anchor="' + anchor + '"]');

		$(section).find('.block').each((i, e) => {
			let bg = $(e).find('.bg');
			let bgW = bg.attr('data-width');
			let duration = bgW * 1.1;
			let cntnt = $(e).find('.cntnt');
			let delayBlockFirst = 250;
			let delayBlock = 100 * i;

			bg.stop().delay(delayBlockFirst + delayBlock).animate({
				'max-width': bgW + 'px'
			}, duration, this.sectionEasing);

			cntnt.stop().delay(delayBlockFirst + delayBlock + duration/2).animate({
				'opacity': 1
			}, duration, this.sectionEasing);
		});
	}

	updateElementsColor(nextIndex) {
		if(nextIndex < 2) {
			return;
		}

		let section = $('#fullpage').find('.section')[nextIndex - 1];
		let color = $(section).data('color');

		if(color !== undefined) {
			// logo
			let logo = $('header').find('.logo');
			logo.css('opacity', 1);
			$(logo).find('.border').css('fill', '#ffffff');
			$(logo).find('.bg').css('fill', color);
			$(logo).find('.figure').css('fill', '#ffffff');
		}
	}

	/*
	████████████████████████████
	█ ███ ██     ██ ███ ██ ███ █
	█  █  ██ ██████ ███ ██ ███ █
	█ █ █ ██ ██████  ██ ██ ███ █
	█ ███ ██   ████ █ █ ██ ███ █
	█ ███ ██ ██████ ██  ██ ███ █
	█ ███ ██ ██████ ███ ██ ███ █
	█ ███ ██     ██ ███ ███   ██
	████████████████████████████
	████████████████████████████
	████████████████████████████
	*/
	toggleMenu(state) {
		this.menuOpened = (state !== undefined) ? state : !this.menuOpened;

		$('.menu').toggleClass('opened', this.menuOpened);
		$('.menuPanel').toggleClass('opened', this.menuOpened);

		if(this.menuOpened) {
			this.disableScroll();
		} else {
			this.enableScroll();
		}
	}

	updateMenu(anchor) {
		this.switchMenuItems(anchor);
	}

	switchMenuItems(anchor) {
		let item = $('.menuPanel').find('.item[data-anchor="' + anchor + '"]');
		if(this.itemCurrent !== item) {

			if(this.itemCurrent !== null) {
				this.itemPrevious = this.itemCurrent;
				this.deactivateMenuItem(this.itemPrevious);
			}

			this.itemCurrent = item;
			this.activateMenuItem(this.itemCurrent, anchor);
		}
	}

	/*
	█████████████████████
	█ ███ ███   ███ ███ █
	█ ███ ██ ███ ██ ███ █
	█  ██ ██ ███ ██ ███ █
	█ █ █ ██     ██ ███ █
	█ ██  ██ ███ ███ █ ██
	█ ███ ██ ███ ███ █ ██
	█ ███ ██ ███ ████ ███
	█████████████████████
	█████████████████████
	█████████████████████
	*/
	toggleNav(state) {
		this.navOpened = (state !== undefined) ? state : !this.navOpened;

		$('.nav').toggleClass('opened', this.navOpened);
	}

	updateNav(anchor) {
		let section = $('.section[data-anchor="' + anchor + '"]');
		let sectionColor = section.attr('data-color');

		this.switchNavDots(sectionColor);
	}

	activateMenuItem(item) {
		item.css({
			'text-decoration': 'underline'
		});
	}

	deactivateMenuItem(item) {
		item.css({
			'text-decoration': 'none'
		});
	}

	switchNavDots(color) {
		let dot = $('.dot[data-color="' + color + '"]');
		if(this.dotCurrent !== dot) {

			if(this.dotCurrent !== null) {
				this.dotPrevious = this.dotCurrent;
				this.deactivateNavDot(this.dotPrevious);
			}

			this.dotCurrent = dot;
			this.activateNavDot(this.dotCurrent, color);
		}
	}

	activateNavDot(dot, color) {
		dot.css({
			'background': color,
			'border': 'solid 0px #ffffff'
		});
	}

	deactivateNavDot(dot) {
		dot.css({
			'background': 'rgba(255, 255, 255, 0)',
			'border': 'solid 3px #ffffff'
		});
	}

	/*
	█████████████████████████████████████████████████
	██   ███ ███ ██     ██    ███ ███████   ███ ███ █
	█ ███ ██ ███ ██ ██████ ███ ██ ██████ ███ ██ ███ █
	█ ███ ██ ███ ██ ██████ ███ ██ ██████ ███ ██ ███ █
	█ ███ ██ ███ ██   ████ ███ ██ ██████     ███ █ ██
	█ ███ ███ █ ███ ██████    ███ ██████ ███ ████ ███
	█ ███ ███ █ ███ ██████ ██ ███ ██████ ███ ████ ███
	██   █████ ████     ██ ███ ██     ██ ███ ████ ███
	█████████████████████████████████████████████████
	█████████████████████████████████████████████████
	█████████████████████████████████████████████████
	*/
	openOverlay() {
		$('#fullpage').fullpage.setAllowScrolling(false);

		let section = $('.section[data-anchor="' + this.sectionCurrent + '"]');
		let color = section.attr('data-color');

		// copy content
		let descCntnt = section.find('.content').find('.desc').find('.cntnt').html();
		var overlayCntnt = $('.overlay').find('.content').find('.cntnt').empty().html(descCntnt);

		// set color
		$('.overlay').find('.bg').css('background', color);

		$('.overlay').addClass('opened');

		// scrollbar
		this.setOverlayScrollbar();

		this.disableScroll();

		$('main').css({
			'height': '100%',
			'overflow': 'hidden'
		});
	}

	setOverlayScrollbar() {
		$('.overlay').find('.content').css('height', '100%');
		$('.overlay').find('.content').find('.cntnt').css('height', '100%');
		$('.overlay').find('.bg').height($('.overlay').find('.content').height());

		var overlayCntnt = $('.overlay').find('.content').find('.cntnt');

		var marginV = $('body').height() * 0.04;
		var el = $('.overlay').find('.content');
		var elH = el.innerHeight() - marginV;

		overlayCntnt.find('.scrll').stop().mCustomScrollbar('destroy').css({
			'height': 'auto'
		});

		if(overlayCntnt.find('.scrll').innerHeight() > elH) {
			overlayCntnt.find('.scrll').attr('data-needScroll', 'true');
		} else {
			overlayCntnt.find('.scrll').attr('data-needScroll', 'false');
		}

		if(overlayCntnt.find('.scrll').attr('data-needScroll') === 'true') {
			overlayCntnt.find('.scrll').stop().css({
				'height': elH + 'px'
			}).mCustomScrollbar({
				mouseWheel: { enable: true },
				scrollButtons: { scrollType: 'stepless' },
				keyboard: { scrollType: 'stepless' },
				scrollbarPosition: 'outside',
			});

			overlayCntnt.find('.scrll').find('.mCustomScrollBox').css({
				'-webkit-overflow-scrolling': 'auto'
			});
		} else {
			$('.overlay').find('.content').css('height', 'auto');
			$('.overlay').find('.content').find('.cntnt').css('height', 'auto');
			$('.overlay').find('.bg').height($('.overlay').find('.content').height());
		}
	}

	closeOverlay() {
		$('#fullpage').fullpage.setAllowScrolling(true);

		$('.overlay').removeClass('opened');

		this.enableScroll();
	}

	displayBody() {
		this.fullpageInited = true;
		$('body').addClass('active');
	}

	/*
	██████████████████████████████████████████
	█ ███ ███   ████   ████   ███     ███   ██
	█  █  ██ ███ ██ ███ ██ ███ ████ ████ ███ █
	█ █ █ ██ ███ ██ ██████ ███ ████ ████ █████
	█ ███ ██ ███ ███   ███     ████ ████ █████
	█ ███ ██ ███ ██████ ██ ███ ████ ████ █████
	█ ███ ██ ███ ██ ███ ██ ███ ████ ████ ███ █
	█ ███ ███   ████   ███ ███ ██     ███   ██
	██████████████████████████████████████████
	██████████████████████████████████████████
	██████████████████████████████████████████
	*/
	updateMosaic() {
		let logosContainer = $('.logos').find('.cntnt');
		let logosContainerWidth = $('.logos').find('.cntnt').width();
		let logosContainerHeight = $('.logos').find('.cntnt').height();
		let logosNb = $('.logos').find('.cntnt').children().length;
		let rowsNb = (logosContainerWidth > logosContainerHeight) ? Math.floor(Math.sqrt(logosNb)) : Math.ceil(Math.sqrt(logosNb));
		let logosByRowsNb = Math.ceil(logosNb / rowsNb);
		let logosWidth = logosContainerWidth / logosByRowsNb;
		let logosHeight = logosContainerHeight / rowsNb;

		for (let logoCount = 0, rowCount = 0, colCount = 0; logoCount < logosNb; logoCount++) {
			let logo = $(logosContainer.children()[logoCount]);
			let logoTop = logosHeight * rowCount;
			let logoLeft = logosWidth * colCount;

			if(rowCount === rowsNb - 1) {
				let logosLastRowNb = logosByRowsNb - ((logosByRowsNb * rowsNb) - logosNb);
				let leftMargin = (logosContainerWidth - (logosWidth * logosLastRowNb)) / 2;

				logoLeft += leftMargin;
			}

			logo.css({
				'width': logosWidth + 'px',
				'height': logosHeight + 'px',
				'top': logoTop + 'px',
				'left': logoLeft + 'px'
			});

			if(logoCount % logosByRowsNb === logosByRowsNb - 1) {
				rowCount++;
				colCount = 0;
			} else {
				colCount++
			}

			logo.find('img').removeClass('fillheight fillwidth');

			if(logo.find('img').height() / logo.find('img').width() > 1 || logo.find('img').height() / logo.find('img').width() < 1) {
				// PORTRAIT
				if(logo.width() < logo.find('img').width()) {
					logo.find('img').addClass('fillheight');
				}
				if(logo.height() < logo.find('img').height()) {
					logo.find('img').addClass('fillwidth');
				}

				var marginTop = (logo.height() - logo.find('img').height()) / 2;
				logo.find('img').css({
					'margin-top': marginTop + 'px',
					'margin-bottom': marginTop + 'px'
				});

				var marginLeft = (logo.width() - logo.find('img').width()) / 2;
				logo.find('img').css({
					'margin-left': marginLeft + 'px',
					'margin-right': marginLeft + 'px'
				});
			}
		}
	}

	/*
	██████████████████████████████████████████
	██   ████   ███    ████   ███ ██████ █████
	█ ███ ██ ███ ██ ███ ██ ███ ██ ██████ █████
	█ ██████ ██████ ███ ██ ███ ██ ██████ █████
	██   ███ ██████ ███ ██ ███ ██ ██████ █████
	█████ ██ ██████    ███ ███ ██ ██████ █████
	█ ███ ██ ███ ██ ██ ███ ███ ██ ██████ █████
	██   ████   ███ ███ ███   ███     ██     █
	██████████████████████████████████████████
	██████████████████████████████████████████
	██████████████████████████████████████████
	*/
	preventDefault(e) {
		e = e || window.event;
		if (e.preventDefault) {
			e.preventDefault();
		}
		e.returnValue = false;
	}

	preventDefaultForScrollKeys(e) {
		if (this.keys[e.keyCode]) {
			this.preventDefault(e);
			return false;
		}
	}

	disableScroll() {
		if (window.addEventListener) {
			// older FF
			window.addEventListener('DOMMouseScroll', this.preventDefault, false);
		}
		window.onwheel = this.preventDefault; // modern standard
		window.onmousewheel = document.onmousewheel = this.preventDefault; // older browsers, IE
		window.ontouchmove = this.preventDefault; // mobile
		document.onkeydown = this.preventDefaultForScrollKeys;
	}

	enableScroll() {
		if (window.removeEventListener) {
			window.removeEventListener('DOMMouseScroll', this.preventDefault, false);
		}
		window.onmousewheel = document.onmousewheel = null;
		window.onwheel = null;
		window.ontouchmove = null;
		document.onkeydown = null;
	}
}



/** WEBPACK FOOTER **
 ** ./src/js/Site.js
 **/